import URL from '../../config/url';
import queryString from 'query-string';
import {StorageEntryType} from '../../types/metadata/StorageEntryType';

export type MarketplaceDownloadRequest = {
  resourceName: string;
  integrationId: string;
  resourceType: StorageEntryType;
};

export function MarketplaceDownloadUrl(query: MarketplaceDownloadRequest) {
  return queryString.stringifyUrl({
    url: URL.MARKETPLACE_DOWNLOAD_ARTIFACT,
    query,
  });
}
